import { MenuItemInput } from '../menu.utils';
import NNCIcon from '@/icons/nnc';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PollOutlinedIcon from '@mui/icons-material/PollOutlined';

export const nncMenu: MenuItemInput[] = [
  {
    name: 'NNC Management',
    icon: <NNCIcon />,
    path: '/nnc/management',
  },
  {
    name: 'My Tasks',
    icon: <PeopleAltOutlinedIcon />,
    path: '/nnc/tasks',
    badge: true,
    badgeIndex: 'tasks',
  },
  {
    name: 'NNC',
    icon: <NNCIcon />,
    submenu: [
      {
        name: 'NNC Entries',
        path: '/nnc/entries',
        permission: 'nnc.nnc',
      },
      {
        name: 'All Analysis',
        path: '/nnc/criticalanalysis',
        permission: 'nnc.criticalanalysis',
      },
      {
        name: 'Fail Mode Entries',
        path: '/nnc/failuremode',
        permission: 'nnc.failuremode',
      },
      {
        name: 'All Action Plans',
        path: '/nnc/actionplan',
        permission: 'nnc.actionplan',
      },
      {
        name: 'All Actions',
        path: '/nnc/actionplanitem',
        permission: 'nnc.actionplanitem',
      },
    ],
  },

  {
    name: 'Configuration',
    icon: <SettingsApplicationsIcon />,
    submenu: [
      {
        name: 'Origin',
        path: '/nnc/origin',
        permission: 'nnc.origin',
      },
      {
        name: 'Cause',
        path: '/nnc/cause',
        permission: 'nnc.cause',
      },
    ],
  },
  {
    name: 'Reports',
    icon: <PollOutlinedIcon />,
    submenu: [
      {
        name: 'NNCs',
        path: '/nnc/report-nnc',
        permission: 'nnc.nnc',
      },
      {
        name: 'Action Plans',
        path: '/nnc/report',
        permission: 'nnc.nnc',
      },
    ],
  },
];
